import './js/support.js';
import './js/header.js';
import './js/fire-base.js';
import './js/burger.js';
// import './js/pagination.js';
import './js/dark-theme.js';
import './js/shop-list.js';
